<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 1.75C2.3 1.75 1.93 2.58 2.4 3.08L11.93 13.43C12.13 13.63 12.4 13.75 12.7 13.75H13.78L6.3 5.35C4.53 3.38 4.05 1.75 3 1.75Z" fill="#18A999" />
    <path d="M13 1.75C13.7 1.75 14.08 2.58 13.6 3.08L4.08 13.43C3.88 13.63 3.6 13.75 3.3 13.75H2.23L9.7 5.35C11.48 3.38 11.95 1.75 13 1.75Z" fill="#315FEA" />
    <path d="M6.2 7.2L8 9.18L9.8 7.2L8 5.2L6.2 7.2Z" fill="#17355F" />
  </svg>
</template>
